<template>
	<div>
		<div v-if="manufacturer">
			<div>
				<div class="p-5">
					<div class="d-flex justify-content-between">
						<h1 v-if="manufacturerPageTitel">{{ manufacturerPageTitel }}</h1>
					</div>
					<a @click="openHamburgerMenu" class="hidden-lg">Visa fler kategorier för {{$route.params.name}}</a>
					<html-description v-if="manufacturerPage.description" ref="description" :html="manufacturerPage.description" />
				</div>
				<div class="clearfix" />
			</div>
			<product-browser
				v-if="showBrowser"
				ref="browser"
				:manufacturerPage="manufacturerPage"
				:canSetPageQuery="browserCanSetPage"
				:alwaysResetResultCount = true
				:canSetCanonical="false"
				:resetData="resetData"
				:url="'manufacturer/' + manufacturer.id + '/category/' + category.id"
				@loaded="onPageLoad"
			/>
		</div>
	</div>
</template>

<script>
import bus from 'eventbus';
import router from 'router';
import store from 'datastore';
import { mapState } from "vuex";
import metaHandler from 'metaHandler';
import { urlFormat, htmlToText, error } from 'utils';
import { loadManufacturerTree, setSectionAndCategories } from 'datastore/navStatus';

export default {
	handlesPrerender: true,
	layoutOptions: {
		leftCol: true,
	},
	data () {
		return {
			manufacturerPage: null,
			manufacturer: null,
			category: null,
			categoryId: null,
			browserCanSetPage: true,
			resetData: [],
		};
	},
	beforeRouteEnter (to, frm, next) {
		waja.get('manufacturer-page/' + to.params.id + '/' + to.params.categoryId + '/' + store.getters['i18n/regionCode'])
			.useCdn(true)
			.on('success', res => {
				next((vm) => {
					vm.manufacturerPage = res.data.manufacturerPage;
					vm.manufacturer = vm.manufacturerPage.manufacturer;
					vm.category = vm.manufacturerPage.category;
					loadManufacturerTree(vm.manufacturer);//@ TODO: Don't do redundant reloads.
					setSectionAndCategories(vm.manufacturer, vm.category.path);
				});
			})
			.on('error', () => {
				next(error(404));
			}).go();
	},
	beforeRouteUpdate (to, frm, next) {
		if (~~to.params.id === ~~frm.params.id && ~~to.params.categoryId === ~~frm.params.categoryId) {
			next();
			return;
		}

		waja.get('manufacturer-page/' + to.params.id + '/' + to.params.categoryId + '/' + store.getters['i18n/regionCode'])
			.useCdn(true)
			.on('success', res => {
				next((vm) => {
					vm.manufacturerPage = res.data.manufacturerPage;
					vm.manufacturer = vm.manufacturerPage.manufacturer;
					vm.category = vm.manufacturerPage.category;
					loadManufacturerTree(vm.manufacturer);
					setSectionAndCategories(vm.manufacturer, vm.category.path);
				});
			})
			.on('error', () => {
				next(error(404));
			}).go();
	},
	computed: {
		manufacturerPageTitel () {
			return this.manufacturerPage.name || this.manufacturer.name + " - " + this.category.name;
		},
		showBrowser () {
			return this.category.id;
		},
		...mapState({
			burgerOpen: state => state.navStatus.menu.burgerOpen,
		}),
	},
	methods: {
		openHamburgerMenu () {
			this.browserCanSetPage = false;
			store.commit('navStatus/burgerOpen', true);
		},
		getName() {
			this.name =  this.manufacturerPage.name ? this.manufacturerPage.name : this.manufacturer.name + ' - ' +  this.category.name;
		},
		onPageLoad () {
			store.dispatch('prerender/pageLoaded');
		},
	},
	watch: {
		burgerOpen (isOpen) {
			if (! isOpen) {
				setTimeout(() => {
					this.browserCanSetPage = true;
				}, 100);
			}
		},
		manufacturerPage () {
			// Correct params if necessary.
			router.updateParams({
				id: this.manufacturer.id,
				name: urlFormat(this.manufacturer.name),
				categoryId: this.category.id,
				categoryName: urlFormat(this.category.name),
			});

			/*
			* SEO.
			*/

			let metaDescription = 'Stort utbud av ' + this.manufacturer.name + ' ' + this.category.name + '. ✓ Låga priser ✓ Öppet köp 30 dagar ✓ Fri frakt för medlemmar - Köp online eller i butik!';
			const description = this.manufacturerPage.metaDescription ||  htmlToText(this.manufacturerPage.description);
			if (description) {
				metaHandler.set('description', description);
			} else {
				metaHandler.set('description', metaDescription);
			}

			/*
			* END SEO.
			*/

			// Check if the manufacturer has set a custom takeover image.
			if (this.manufacturer.takeoverUrl && this.manufacturer.takeoverUrl !== '') {
				bus.$emit('takeover:update', {
					manufacturer: this.manufacturer,
					imageUrl: this.manufacturer.takeoverUrl,
				});
			}

			// Init product browser.
			if (this.manufacturer?.id && this.category?.id) {
				this.resetData = [
					[{
						type: 'manufacturer',
						value: this.manufacturer.id,
						label: this.manufacturer.name,
						hidden: true,
						persistOnClear: true,
					}, {
						type: 'category',
						value: this.category.id
					}],
					[{
						type: 'hideFyndwares',
						value: true,
						hidden: true,
						persistOnClear: true,
					}],
					true,
				];
			} else {
				Vue.nextTick(() => {
					this.onPageLoad();
				});
			}
		}
	},
}
</script>